import React from 'react';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';
import Button from 'reusecore/src/elements/Button';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';
import BannerWrapper, {
  BannerObject,
} from './bannerSection.style';
import WistiaVideo from './wistiaVideo';

const DemoSection = ({
  row,
  col,
  title,
  description,
  buttonWrapper,
  button,
}) => {
  return (
    <BannerWrapper id="demo_section">
      <Container>
        <Box className="row" {...row}>
          <Box className="col" {...col}>
            <FeatureBlock
              title={
                <Heading
                  content="Overview"
                  {...title}
                />
              }
              description={
                <div>
                  <Text
                    content="This video is a quick demonstration of core functionality, including projects, dataset exploration, notebook commenting and running a notebook."
                    {...description}
                  />
                  <Text
                    content="To find out more, sign-up for a free 30-day trial."
                    {...description}
                  />
                </div>
              }
            />
          </Box>
        </Box>
        <Box {...buttonWrapper}>
          <a href="https://europanb.atlassian.net/wiki/spaces/EN/pages/2162693/Europa+Notebooks+Documentation">
            <Button {...button} />
          </a>
        </Box>
      </Container>
      <BannerObject>
        <WistiaVideo />
      </BannerObject>
    </BannerWrapper>
  );
};

DemoSection.propTypes = {
  title: PropTypes.object,
  btnStyle: PropTypes.object,
  description: PropTypes.object,
  contentStyle: PropTypes.object,
  discountText: PropTypes.object,
  discountAmount: PropTypes.object,
  outlineBtnStyle: PropTypes.object,
};

DemoSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  col: {
    pr: '15px',
    pl: '15px',
    width: [1, '70%', '50%', '45%'],
  },
  title: {
    fontSize: ['22px', '34px', '30px', '40px'],
    fontWeight: '700',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: ['20px', '25px'],
    lineHeight: '1.5',
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '0',
  },
  buttonWrapper: {
    mt: '300px', //`${11}`,
    flexBox: true,
    justifyContent: 'center',
  },
  button: {
    title: 'DOCUMENTATION',
    type: 'button',
    fontSize: `${2}`,
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'primary',
    height: `${4}`,
  },
};

export default DemoSection;